var pubsub = require('pubsub');
var classList = require('dom-classlist');


module.exports = function () {
	var _filterForm = document.querySelector('#filtersForm')
	if(!_filterForm) return;
	var _filters = _filterForm.querySelectorAll('label')

	addHandlers()

	function addHandlers() {
		Array.prototype.forEach.call(_filters, function(el) {
			el.addEventListener('click', clickFilter)
		})
		
	}

	function clickFilter(e) {
		pubsub.emit('load:getStatus', function (isLoading){
			if(isLoading){
				e.preventDefault()
			} else{
				
				var _labelClicked = e.target
				,	_relatedInput = _labelClicked.parentNode.querySelector('input')

				//comportement de radiobutton pour les "fake radio" (radio buttons qu'on peut uncheck > ajout de .fake-radio à l'input type checkbox)
				if(classList(_relatedInput).contains('fake-radio')){
					var _fakeRadios = _relatedInput.parentNode.parentNode.querySelectorAll('.fake-radio')
					Array.prototype.forEach.call(_fakeRadios, function(el) {
						if(el !== _relatedInput) el.checked = false;
					})
				}

				// timeout pour serialize form OK
				setTimeout(function(){

					pubsub.emit('load:more', true);

				}, 200)
				
			}
		});
		
	} 
}
